import Vue from 'vue'
import VueSVGIcon from 'vue-svgicon'
import './assets/icons';
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import { store }  from './store';
import AlertCmp from "./components/shared/Alert";
import LoadingContainer from './components/shared/LoadingContainer';
import interceptorsSetup from './interceptors'


import { 
  humanReadableDate, 
  humanReadableDateTime,
  getRiskBubbleColor,
  getNumberOfSymptomsText,
  timeSince,
  getGenderText,
  calculateAgeFromDate
} from './helpers';

Vue.config.productionTip = false;
Vue.component('app-alert', AlertCmp);
Vue.component('loading-container', LoadingContainer);

Vue.use(VueSVGIcon)

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        if (typeof vnode.context[binding.expression] === 'function') {
          vnode.context[binding.expression](event);
        }
        
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

Vue.mixin({
  methods: {
    timeSince,
    humanReadableDate,
    humanReadableDateTime,
    getRiskBubbleColor,
    getNumberOfSymptomsText,
    getGenderText,
    calculateAgeFromDate
  }
})

interceptorsSetup()


window.app = new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),

  created () {
    this.$vuetify.theme.themes.light = {
      background: '#f7fbfd',
      primary: '#29a8e3',
      light: '#32b6ec',
      secondary: '#b0bec5',
      accent: '#8c9eff',
      error: '#b71c1c',
      white: '#ffffff',
      dark: '#555f6b',
      grey: '#222c38'
    }
    
    if (store.getters['admins/isLoggedIn']) {
      store.dispatch('admins/autoSignIn');
    }
    store.commit('initialLoad')
  }
}).$mount('#app')